<img src="../../../assets/images/login-closee.svg" class="close-btn position-absolute" (click)="close()" alt="">
<div class="position-relative card border-0 signup_form">

  <!-- ── Step 1: Email Gate ──────────────────────────────────────────── -->
  <div @fadeSlideIn class="email-step" *ngIf="step === 'email' && !isSignUpSuccess">
    <div class="d-flex justify-content-center align-items-center mb-3">
      <h2 class="text-center title fw-bold m-0">New Member</h2>
    </div>
    <p class="sub-title fs-14 my-2 text-center">Enter your registered email to continue</p>

    <form [formGroup]="emailForm" class="form" (ngSubmit)="checkEmail()">
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Email *</mat-label>
            <input type="email" matInput formControlName="emailCheck"
              placeholder="company@email.com" autocomplete="email">
            <mat-error *ngIf="emailForm.get('emailCheck')?.touched && emailForm.get('emailCheck')?.invalid">
              <ng-container *ngIf="emailForm.get('emailCheck')?.errors?.required">Email is required.</ng-container>
              <ng-container *ngIf="emailForm.get('emailCheck')?.errors?.email && !emailForm.get('emailCheck')?.errors?.required">Please enter a valid email.</ng-container>
            </mat-error>
          </mat-form-field>
          <p class="email-check-error" *ngIf="emailCheckError">{{ emailCheckError }}</p>
        </div>
      </div>

      <button type="submit" class="btn text-white rounded-pill signup-btn w-100 mt-2 mb-3"
        [disabled]="emailForm.invalid || emailCheckLoading">
        <span *ngIf="!emailCheckLoading">Continue</span>
        <span *ngIf="emailCheckLoading" class="d-flex align-items-center justify-content-center gap-2">
          <span class="email-check-spinner"></span>Verifying&hellip;
        </span>
      </button>
    </form>

    <div class="text-center mb-2">
      <span class="fs-13 color-44">Not approved yet?&nbsp;</span>
      <span class="fs-13 pointer fw-500" style="color: #00625F;" (click)="goToInterestMode()">Register Interest</span>
    </div>
    <div class="fs-14 color-44 d-flex justify-content-between px-3 mt-2">
      <span>Existing User? <a class="fw-500 pointer" style="color: #00625F;" (click)="openDialog($event)">Login</a></span>
      <span class="fs-15 pointer privacyState" (click)="privacyStatement()"><u>Privacy Statement</u></span>
    </div>
  </div>

  <!-- ── Step 2: Registration Form ──────────────────────────────────── -->
  <div @fadeSlideIn *ngIf="step === 'form' && !isSignUpSuccess">

    <div class="position-relative">
      <button *ngIf="!isInterestMode" type="button" class="step-back-btn" (click)="backToEmailStep()">
        &#8592; Change email
      </button>
      <div class="alert alert-info text-center" *ngIf="isInterestMode">
        You're registering interest for a company not yet listed.
      </div>
      <div class="d-flex justify-content-center align-items-center" style="margin-bottom: 15px;">
        <h2 class="text-center title fw-bold m-0">New Member</h2>
      </div>
      <p class="sub-title fs-14 my-2 text-center">Please fill up the form to sign up</p>
      <p class="text-primary pointer text-center" *ngIf="!isInterestMode" (click)="enableInterestMode()">
        Don't see your company listed? Click here to register interest
      </p>
    </div>

    <form [formGroup]="singupForm" class="form">
      <div class="row">
        <div class="col-md-12">
          <div class="position-relative">
            <mat-form-field appearance="outline" class="example-full-width w-100">
              <mat-label>Email *</mat-label>
              <input type="email" matInput formControlName="email" placeholder="company@email.com">
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="singupForm.get('email')?.touched && singupForm.get('email')?.invalid">
                <ng-container *ngIf="singupForm.get('email')?.errors?.required">Email is required.</ng-container>
                <ng-container *ngIf="singupForm.get('email')?.errors?.email && !singupForm.get('email')?.errors?.required">Please enter a valid email.</ng-container>
                <ng-container *ngIf="singupForm.get('email')?.errors?.domainInvalid">Email domain must match the company&apos;s registered domain.</ng-container>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="position-relative">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Country *</mat-label>
              <mat-select formControlName="country" (selectionChange)="onCountryChange($event.value)">
                <mat-option *ngFor="let c of countries" [value]="c.id">{{ c.name }}</mat-option>
              </mat-select>
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="(singupForm.get('country')?.touched || singupForm.get('country')?.dirty) && singupForm.get('country')?.invalid">
                Country is Required *.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="position-relative">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Industry / Sector *</mat-label>
              <mat-select formControlName="sector" [disabled]="!singupForm.get('country')?.value"
                (selectionChange)="onSectorChange($event.value)">
                <mat-option *ngFor="let s of sectors" [value]="s.id">{{ s.name }}</mat-option>
              </mat-select>
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="(singupForm.get('sector')?.touched || singupForm.get('sector')?.dirty) && singupForm.get('sector')?.invalid">
                Sector is Required *.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="position-relative">
            <mat-form-field appearance="outline" class="w-100" *ngIf="!isInterestMode">
              <mat-label>Company Name *</mat-label>
              <mat-select formControlName="company" [disabled]="!singupForm.get('sector')?.value"
                (selectionChange)="onCompanySelect($event.value)">
                <mat-option *ngFor="let c of companies" [value]="c.id">{{ c.name }}</mat-option>
              </mat-select>
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="(singupForm.get('company')?.touched || singupForm.get('company')?.dirty) && singupForm.get('company')?.hasError('required')">
                Company is Required *.
              </mat-error>
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="singupForm.get('company')?.hasError('userExists')">
                Hi, it looks like your company is not yet listed on the portal. Please register to enable further engagement.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" *ngIf="!isInterestMode">
          <div class="position-relative">
            <mat-form-field appearance="outline" class="example-full-width w-100">
              <mat-label>Number of Employees *</mat-label>
              <input matInput type="number" formControlName="employeeCount" min="1" max="{{maxEmployeeCount}}" (blur)="onEmployeeCountBlur()">
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="(singupForm.get('employeeCount')?.touched || singupForm.get('employeeCount')?.dirty) && singupForm.get('employeeCount')?.hasError('required')">
                Employee Count is Required *.
              </mat-error>
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="singupForm.get('employeeCount')?.hasError('maxEmployeeCountError')">
                Maximum Employee Count should be less than {{maxEmployeeCount}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" *ngIf="!isInterestMode">
          <div class="position-relative">
            <mat-form-field appearance="outline" class="example-full-width w-100">
              <mat-label>MSME Type *</mat-label>
              <mat-select formControlName="msmeType" [disabled]="true">
                <mat-option *ngFor="let c of classifications" [value]="c.id">{{ c.type }}</mat-option>
              </mat-select>
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="(singupForm.get('msmeType')?.touched || singupForm.get('msmeType')?.dirty) && singupForm.get('msmeType')?.hasError('required')">
                MSME Type is Required *.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="position-relative" *ngIf="isInterestMode">
            <mat-form-field appearance="outline" class="example-full-width w-100">
              <mat-label>Company Name *</mat-label>
              <input type="text" appAlphabatesOnly placeholder="Name" matInput formControlName="companyName"
                [ngModelOptions]="{standalone: true}" appSpecialCharactersValidation>
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="(singupForm.get('companyName')?.touched || singupForm.get('companyName')?.dirty) && singupForm.get('companyName')?.invalid">
                Company Name is Required *.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" *ngIf="!isInterestMode">
          <div class="position-relative">
            <mat-form-field appearance="outline" class="example-full-width w-100">
              <mat-label>Name *</mat-label>
              <input matInput type="text" formControlName="name">
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="(singupForm.get('name')?.touched || singupForm.get('name')?.dirty) && singupForm.get('name')?.hasError('required')">
                Name is Required *.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 my-2" *ngIf="!isInterestMode">
          <div class="position-relative">
            <div class="eye-input position-absolute">
              <button class="eye-icon d-flex align-items-center pointerHead" type="button" (click)="showPassword('pass')">
                <img src="{{show ? '/assets/images/eye-password.svg' : '/assets/images/hide.svg'}}" class="img-fluid" alt="">
              </button>
            </div>
            <mat-form-field appearance="outline" class="example-full-width w-100">
              <mat-label>Password *</mat-label>
              <input [type]="!this.show ? 'password' : 'text'" placeholder="Password" matInput
                formControlName="password" autocomplete="off" [ngModelOptions]="{standalone: true}">
              <mat-error class="invalid-feedback mx-3 mb-0"
                *ngIf="(singupForm.get('password')?.touched || singupForm.get('password')?.dirty) && (singupForm.get('password')?.hasError('required') || singupForm.get('password')?.hasError('minlength') || singupForm.get('password')?.hasError('uppercase') || singupForm.get('password')?.hasError('lowercase') || singupForm.get('password')?.hasError('number') || singupForm.get('password')?.hasError('specialCharacter') || singupForm.get('password')?.hasError('space'))">
                Password must have at least one number, one special character, one uppercase letter, one lowercase letter, and be at least 8 characters long except white space.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 my-2" *ngIf="!isInterestMode">
          <div class="position-relative">
            <div class="eye-input position-absolute">
              <button class="eye-icon d-flex align-items-center pointerHead" type="button" (click)="showPassword('cpass')">
                <img src="{{show2 ? '/assets/images/eye-password.svg' : '/assets/images/hide.svg'}}" class="img-fluid" alt="">
              </button>
            </div>
            <mat-form-field appearance="outline" class="example-full-width w-100">
              <mat-label>Confirm Password *</mat-label>
              <input [type]="!this.show2 ? 'password' : 'text'" placeholder="Confirm password" matInput
                formControlName="confirmPassword" autocomplete="new-password" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
            <span class="invalid-feedback mx-3"
              *ngIf="singupForm.hasError('passwordMismatch') && singupForm.get('confirmPassword')?.dirty">
              Password mismatch.
            </span>
          </div>
        </div>
      </div>

      <button type="button" class="btn text-white rounded-pill signup-btn w-100 mt-4 mb-2 my-2"
        (click)="sinUpUser()" [disabled]="singupForm.invalid">
        {{ isInterestMode ? 'Submit Interest' : 'Signup' }}
      </button>

      <div class="text-center my-2" *ngIf="isInterestMode">
        <span class="ms-2 pointer text-primary" (click)="disableInterestMode()">Back to listed companies</span>
      </div>
      <div class="fs-14 color-44 row my-2">
        <div class="col-sm-7">
          <span class="extUser">Existing User?
            <a class="fw-500 pointer" style="color: #00625F;" (click)="openDialog($event)">Login</a>
          </span>
        </div>
        <div class="col-sm-5">
          <span class="fs-15 pointer privacyState" (click)="privacyStatement()"><u>Privacy Statement</u></span>
        </div>
      </div>
    </form>
  </div>

  <!-- ── OTP Verification ───────────────────────────────────────────── -->
  <div *ngIf="isSignUpSuccess">
    <div>
      <div class="col-12 text-center">
        <h2 class="text-center title fw-bold">OTP Verification</h2>
        <p class="fs-14 text-center g-clr">Your OTP has been sent successfully!</p>
      </div>
      <div class="col-12 text-center">
        <p class="fs-14 text-center">Please enter the 6-digit OTP, we have sent on your email id
          <span *ngIf="singupForm" class="em-cls">{{singupForm?.controls?.email?.value}}</span>
        </p>
        <div class="verification-code">
          <form [formGroup]="otpForm">
            <input type="text" #otp1 class="otp-input" maxlength="1"
              (input)="focusNext($event, otp1, otp2)" (keydown)="handleBackspace($event, otp1, otp2,'opt1')" formControlName="otp1">
            <input type="text" #otp2 class="otp-input" maxlength="1"
              (input)="focusNext($event, otp2, otp3)" (keydown)="handleBackspace($event, otp2, otp1,'')" formControlName="otp2">
            <input type="text" #otp3 class="otp-input" maxlength="1"
              (input)="focusNext($event, otp3, otp4)" (keydown)="handleBackspace($event, otp3, otp2,'')" formControlName="otp3">
            <input type="text" #otp4 class="otp-input" maxlength="1"
              (input)="focusNext($event, otp4, otp5)" (keydown)="handleBackspace($event, otp4, otp3,'')" formControlName="otp4">
            <input type="text" #otp5 class="otp-input" maxlength="1"
              (input)="focusNext($event, otp5, otp6)" (keydown)="handleBackspace($event, otp5, otp4,'')" formControlName="otp5">
            <input type="text" #otp6 class="otp-input" maxlength="1"
              (keydown)="handleBackspace($event, otp6, otp5,'')" formControlName="otp6">
          </form>
          <div class="text-danger mt-3 ps-2" *ngIf="errorMessage">{{errorMessage}}</div>
        </div>
      </div>
      <div class="col-12 mt-4">
        <button class="btn text-white rounded-pill signup-btn w-100" (click)="verifyOtp()" [disabled]="isDisabledVerify">Verify</button>
        <div class="fs-14 fw-400 text-center" style="color: #4F4C4D;">OTP will be valid for 10 minutes.</div>
        <div class="fs-14 fw-400 color-secondary text-center">
          <button *ngIf="countdown < 1" class="btn-resend" (click)="resendOtp()" [disabled]="isDisabledResendOtp">Resend OTP</button>
          <div *ngIf="countdown > 0" style="color:#4F4C4D">Resend OTP in {{ countdown }} seconds</div>
        </div>
      </div>
    </div>
  </div>

</div>
